import axios from '../http/axios';
import { PORTAL_SERVICOS_BACKEND } from '../constants/environment';

export default {
	getNpsKey: () => {
		return axios
			.get(`${PORTAL_SERVICOS_BACKEND}/parametro/getValorParametroByDeParametro`, {params: {
					deParametro: "prmNpsKey",
				}})
			.then(res => {
				return res.data;
			});
	}
};
